import { DinnerSection } from '../components/DinnerSection/DinnerSection';
import { LunchSection } from '../components/LunchSection/LunchSection';
import { getPricingVersionFromPlanComponents } from '../utils/getPricingVersionFromPlanComponents';
import { usePlanServiceCustomerPlansView } from './usePlanServiceCustomerPlansView';

export function useLunchDinnerFoodProfileSections(customerId?: number) {
  const {
    data: customerPlanComponentsData,
    isLoading: isLoadingCustomerPlanComponents,
  } = usePlanServiceCustomerPlansView(
    { is_staged: 0 },
    { enabled: customerId !== undefined }
  );

  if (
    customerId === undefined ||
    isLoadingCustomerPlanComponents ||
    customerPlanComponentsData === undefined
  ) {
    return undefined;
  }

  const pricingVersion = getPricingVersionFromPlanComponents(
    customerPlanComponentsData
  );

  if (pricingVersion >= 15) {
    return {
      lunchSection: <LunchSection customerId={customerId} />,
      dinnerSection: <DinnerSection customerId={customerId} />,
    };
  }

  return {
    lunchSection: null,
    dinnerSection: null,
  };
}
